import React from "react";
// UI Framework
import { TableCell } from "@mui/material";
import TimelineIcon from "@mui/icons-material/Timeline";
// Common Component
import Modal from "src/Components/Modal/Modal";
import Button from "src/Components/Button";
// Local Modal
import DailyChartUI from "./DailyChartUI";
import HourlyChartUI from "./HourlyChartUI";
// Types
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "src/Tables/TableTemplate/tableTemplate";
import {
  IPortfolioInsTableReport,
  IPortfolioTableReport,
} from "src/Interfaces/portfolio";

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell />
      <TableCell />
    </>
  );
};

enum ModalMode {
  ChartDaily,
  ChartHourly,
  Closed,
}

const AdditionalCol: React.FC<{
  row: IPortfolioTableReport | IPortfolioInsTableReport;
  onAction: () => void;
}> = React.memo(({ row, onAction }) => {
  const [modalMode, setModalMode] = React.useState(ModalMode.Closed);

  const getModalUI = () => {
    switch (modalMode) {
      case ModalMode.ChartDaily:
        return <DailyChartUI row={row} />;
      case ModalMode.ChartHourly:
        return <HourlyChartUI row={row} />;
    }
    return <></>;
  };

  return (
    <>
      <TableCell>
        {modalMode !== ModalMode.Closed ? (
          <Modal
            UI={getModalUI()}
            onClose={() => {
              setModalMode(ModalMode.Closed);
            }}
            fullScreen
          />
        ) : (
          <></>
        )}
        <div className="w-20 py-1 px-2">
          <Button
            text={
              <>
                <TimelineIcon style={{ fontSize: 16, marginLeft: 4 }} /> تاریخچه
              </>
            }
            onClick={() => setModalMode(ModalMode.ChartDaily)}
            variant="contained"
            className="table-btn "
          />
        </div>
      </TableCell>
      <TableCell>
        <div className="w-20 py-1 px-2">
          <Button
            text={
              <>
                <TimelineIcon style={{ fontSize: 16, marginLeft: 4 }} /> میان
                روز
              </>
            }
            onClick={() => setModalMode(ModalMode.ChartHourly)}
            variant="contained"
            className="table-btn "
          />
        </div>
      </TableCell>
    </>
  );
});

export const Additional: IAdditional<IPortfolioTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
